import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid2,
  MenuItem,
  Typography,
} from "@mui/material";
import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import CommonButton from "../../../../../component/Button";
import CommonTextField from "../../../../../component/Input";
import DropDownSelect from "../../../../../component/Select"; // adjust import path

const OPENAI_MODEL_OPTIONS = [
  { name: "Gpt 5.5", value: "gpt-5.5" },
  { name: "Gpt 4o Mini", value: "gpt-4o-mini" },
  { name: "Gpt 5.4", value: "gpt-5.4" },
  { name: "Gpt 5.4 Mini", value: "gpt-5.4-mini" },
];

export default function CredentialsDialog({
  open,
  onClose,
  connector,
  values,
  onChange,
  onSubmit,
}) {
  const requiredFields = connector?.required_fields || [];
  const isOpenAI = connector?.name === "OpenAI";

  const validationSchema = React.useMemo(() => {
    const shape = {};
    requiredFields.forEach((field) => {
      shape[field.key] = Yup.string()
        .trim()
        .required(`${field.name} is required`);
    });
    // if (isOpenAI) {
    //   shape["global_model"] = Yup.string().required("Model is required");
    // }
    return Yup.object().shape(shape);
  }, [requiredFields, isOpenAI]);

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open.open}
      onClose={onClose}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "12px",
          background: "#FFF",
          boxShadow:
            "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
        },
      }}
    >
      <DialogTitle>
        <Typography variant="h3" marginTop="10px">
          Connect {connector?.name}
        </Typography>
        <Typography variant="body2" color="#667085" marginTop="10px">
          Provide the required credentials
        </Typography>
      </DialogTitle>

      <Formik
        enableReinitialize
        initialValues={{
          ...values,
          ...(isOpenAI && { global_model: values?.global_model ?? "" }),
        }}
        validationSchema={validationSchema}
        onSubmit={() => {
          onSubmit();
        }}
      >
        {({ handleSubmit, handleChange, setFieldValue, touched, errors }) => (
          <>
            <DialogContent sx={{ paddingTop: "12px", overflow: "visible" }}>
              <Grid2 container spacing={3}>
                {requiredFields.map((field, index) => (
                  <Grid2
                    size={12}
                    key={field.key}
                    sx={{ marginTop: index === 0 ? "6px" : 0 }}
                  >
                    <CommonTextField
                      name={field.key}
                      label={field.name}
                      placeholder={field.name}
                      value={values?.[field.key] ?? ""}
                      onChange={(e) => {
                        handleChange(e);
                        onChange(field.key, e.target.value);
                      }}
                      error={Boolean(touched[field.key] && errors[field.key])}
                      helperText={touched[field.key] && errors[field.key]}
                      padding={"12px 14px"}
                      labelShrink={"12px"}
                      placeholderFontSize={"14px"}
                    />
                  </Grid2>
                ))}

                                  {/* ✅ OpenAI Model Dropdown */}
                                  {/* {isOpenAI && (
                    <Grid2 size={12}>
                      <Typography variant="body2" fontWeight={500} marginBottom="6px">
                        Model
                      </Typography>
                      <DropDownSelect
                        customStyle={{ width: "100%" }}
                        marginTop="0px"
                        title={"Select Model"}
                        removeAnimation={true}
                        data={OPENAI_MODEL_OPTIONS}
                        value={values?.global_model ?? ""}
                        handleRenderValue={(selected) => {
                          const found = OPENAI_MODEL_OPTIONS.find((item) => item.value === selected);
                          return found ? found.name : "";
                        }}
                        CustomMenuItem={(item, index) => (
                          <MenuItem key={index} value={item.value}>
                            {item.name}
                          </MenuItem>
                        )}
                        handleChange={(e) => {
                        setFieldValue("global_model", e.target.value);
                    onChange("global_model", e.target.value);
                        }}
                        error={Boolean(touched.global_model && errors.global_model)}
                  helperText={touched.global_model && errors.global_model}
                      />
                    </Grid2>
                  )} */}
              </Grid2>
            </DialogContent>

            <DialogActions sx={{ padding: "0px 16px 16px", gap: "8px" }}>
              <CommonButton
                value="Cancel"
                variant="outlined"
                color="primary"
                onClick={onClose}
                padding="8px 16px"
              />
              <CommonButton
                value="Connect"
                onClick={handleSubmit}
                padding="8px 16px"
                disabled={open.loading}
                loading={open.loading}
              />
            </DialogActions>
          </>
        )}
      </Formik>
    </Dialog>
  );
}